module.exports = __webpack_public_path__ + "img/small.4f2224c0.jpg";